import { darken, lighten, linearGradient, adjustHue } from 'polished';
import styled from 'styled-components';
import { Col, Dropdown, List, Row, Select } from 'antd';
import { EditFilled } from '@ant-design/icons';

const Rank = () => {

    const Texture = (props) => {
        switch (props) {
            case 1: {
                return '#f9ad0e';
            }
            case 2: {
                return '#d1d7da';
            }
            case 3: {
                return '#df7e08';
            }
            default: {
                return '#d1d7da'
            }

        }
    }
    const Medal = styled.div`

      // CSS reset END

        $gold-medal: #f9ad0e;
        $silver-medal: #d1d7da;
        $bronze-medal: #df7e08;
        $neutral-medal: #d1d7da;

        .quiz-medal {
            position: relative;
            margin-bottom: 16px;
        }
        
        .quiz-medal__circle {
            font-family: 'Roboto', sans-serif;
            font-size: 28px;
            font-weight: 500;
            width: 56px;
            height: 56px;
            border-radius: 100%;
            color: white;
            text-align: center;
            line-height: 46px;
            vertical-align: middle;
            position: relative;
            border-width: 0.2em;
            border-style: solid;
            z-index: 1;

        // Default colors
        box-shadow: inset 0 0 0 ${props => {
            const type = {
                gold: props.type === 1,
                silver: props.type === 2,
                bronze: props.type === 3,
                neutral: props.type === 4,
            }
            return darken(0.15, Texture(props.rank))
        }}, 2px 2px 0 rgba(0, 0, 0, 0.08);
        border-color: ${props => lighten(0.1, adjustHue(10, Texture(props.rank)))};
        text-shadow: 2px 2px 0 ${props => darken(0.2, Texture(props.rank))};
        background: ${props =>
            linearGradient({
                toDirection: ['to bottom right'],
                colorStops: [Texture(props.rank) + ' 50%', darken(0.05, Texture(props.rank)) + ' 50%']
            })};
        }

        .quiz-medal__ribbon {
            content: "";
            display: block;
            position: absolute;
            border-style: solid;
            border-width: 6px 10px;
            width: 0;
            height: 20px;
            top: 50px;
        }
        
        .quiz-medal__ribbon--left {
            border-color: #FC402D #FC402D transparent #FC402D;
            left: 8px;
            transform: rotate(20deg) translateZ(-32px);
        }
        
        .quiz-medal__ribbon--right {
            left: 28px;
            border-color: ${props => darken(0.1, '#FC402D')} ${props => darken(0.1, '#FC402D')} transparent ${props => darken(0.1, '#FC402D')};
            transform: rotate(-20deg) translateZ(-48px);
        }
            
    `
    const MetalShow = (props) => {
        if (props.index < 3) {
            return (
                <Medal rank={props.index + 1}>
                    <div class="quiz-medal">
                        <div class="quiz-medal__circle quiz-medal__circle--gold">
                            <span>
                                {props.index + 1}
                            </span>
                        </div>
                        <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
                        <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
                    </div>
                </Medal>
            )
        }
        else {
            return(<div style={{width: '56px', height: '56px', textAlign: 'center', fontSize: '28px', fontWeight: '300'}}>{props.index+1}</div>)
        }
            // return (
            //     <Medal rank={props.index + 1}>
            //         <div class="quiz-medal">
            //             <div class="quiz-medal__circle quiz-medal__circle--gold">
            //                 <span>
            //                     {props.index + 1}
            //                 </span>
            //             </div>
            //             <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
            //             <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
            //         </div>
            //     </Medal>
            // )
    }
    const data = [
        {
            title: '南方，寂寞鐵道：我們在時光列車上相遇',
            description: 'On the Rail',
        },
        {
            title: '貓主子的科學：喵皇賣萌大小事',
            description: 'Catology : The Weird and Wonderful Science of Cats',
        },
        {
            title: '電玩遊戲進化史【圖解漫畫版】：從桌遊、RPG、任天堂到VR，回味玩心設計大躍進的魅力指南',
            description: 'Gamish: A Graphic History of Gaming',
        },
        {
            title: '快速開飯的5分鐘預漬備料魔法：只要學會就能10分鐘快速上桌，92道讓你天天省時輕鬆煮的美味提案！',
            description: '仕込み5分の漬けとく献立',
        },
    ];
    const timeRange = [
        {
            value: 'day',
            label: '日',
        },
        {
            value: 'week',
            label: '週',
        },
        {
            value: 'month',
            label: '月',
        },
        {
            value: 'season',
            label: '季',
        },
        {
            value: 'year',
            label: '年',
        },
    ]
    return (
        <div style={{ width: '100%', height: '100%', overflowY: 'scroll', overflowX: 'hidden' }}>
            <List
                header={
                    <Row justify={'space-between'}>
                        <Col />
                        <Col>
                            <span style={{ fontSize: '1.3em', fontWeight: '500' }}>書籍借閱排行</span>
                        </Col>
                        <Col>
                            <Select
                                defaultValue="月"
                                // style={{
                                //     width: 120,
                                // }}
                                options={timeRange}
                            />
                        </Col>
                    </Row>

                }
                dataSource={data}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={
                                <MetalShow index={index} />
                                // <Medal rank={index + 1}>
                                //     <div class="quiz-medal">
                                //         <div class="quiz-medal__circle quiz-medal__circle--gold">
                                //             <span>
                                //                 {index + 1}
                                //             </span>
                                //         </div>
                                //         <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
                                //         <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
                                //     </div>
                                // </Medal>
                                // {/* // <Medal><span className="quiz-medal__circle quiz-medal__circle--gold">1122</span></Metal> */}
                            }
                            title={<a href="https://ant.design">{item.title}</a>}
                            description={item.description}
                        />
                    </List.Item>
                )}
            />
        </div>
    )
}

export default Rank